import React, { useEffect, useState } from "react";
import { Flame, CalendarCheck, Gamepad2, Star } from "lucide-react";
import { api } from "@/lib/api";

const BOARDS = {
  quiz: { url: "/leaderboard/quiz-streaks", icon: Flame, title: "Quiz Streak badges", blurb: "Earned by scoring 5/5 on 3 Music Helper practice quizzes in a row.",
    empty: "No badges yet. Be the first: open a lesson, tap Ask the Music Helper, then Quiz me.", id: "quiz-streak" },
  practice: { url: "/leaderboard/practice-streaks", icon: CalendarCheck, title: "Practice Streak badges", blurb: "Earned by ticking off all six practice days (Sunday to Friday) in a week.",
    empty: "No badges yet. Tick off every practice day this week to be the first.", id: "practice-streak" },
  game: { url: "/leaderboard/game-streaks", icon: Gamepad2, title: "Game Streak badges", blurb: "Earned by playing the lesson games on 5 different days in one week (Sunday to Saturday).",
    empty: "No badges yet. Play a lesson game on 5 days this week to be the first.", id: "game-streak" },
  gotw: { url: "/leaderboard/gotw", icon: Star, title: "Game of the Week badges", blurb: "Earned by playing the featured Game of the Week 3 times in that week.",
    empty: "No badges yet. Play this week's featured game 3 times to be the first.", id: "gotw" },
};

// Leaderboard section listing students with streak badges.
export const StreakBoard = ({ kind }) => {
  const b = BOARDS[kind];
  const [list, setList] = useState(null);
  useEffect(() => { api.get(b.url).then(({ data }) => setList(data.students)).catch(() => setList([])); }, [b.url]);
  if (!list) return null;
  return (
    <section className="mt-10 rounded-3xl border border-border bg-card p-6" data-testid={`${b.id}-board`}>
      <h2 className="flex items-center gap-2 font-serif text-2xl"><b.icon size={20} className="text-primary" /> {b.title}</h2>
      <p className="mt-1 text-sm text-muted-foreground">{b.blurb}</p>
      {!list.length ? <p className="mt-4 text-sm text-muted-foreground" data-testid={`${b.id}-empty`}>{b.empty}</p> : (
        <div className="mt-4 grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-4">
          {list.map((s, i) => (
            <div key={i} className="rounded-2xl border border-primary/30 bg-background p-4" data-testid={`${b.id}-student-${i}`}>
              <p className="font-serif text-lg">{s.name}</p>
              <p className="mt-1 inline-flex items-center gap-1 font-mono text-[10px] uppercase tracking-widest text-primary"><b.icon size={11} /> {s.badges} {s.badges === 1 ? "badge" : "badges"}</p>
            </div>
          ))}
        </div>
      )}
    </section>
  );
};

export const QuizStreakBoard = () => <StreakBoard kind="quiz" />;
